import Api from "./base/api-base";

export default class ConstructionDailyReportApi {
    all() {
      return Api.get({
        endpoint: Api.endpoint.construction_daily_report_all
      });
    }

    list() {
      return Api.get({
        endpoint: Api.endpoint.construction_daily_report
      });
    }

    info(date, id) {
      return Api.link.get({
        links: [
          {endpoint: Api.endpoint.construction_daily_report, id: date},
          {endpoint: Api.endpoint.construction, id: id}
        ]
      });
    }

    store (params) {
      return Api.post({
        endpoint: Api.endpoint.construction_daily_report,
        params: params
      });
    }

    update (date, params) {
      return Api.post({
        endpoint: Api.endpoint.construction_daily_report,
        id: date,
        params: params
      });
    }
}